function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { j as a } from "./index.es33.js";
import { clsx as p } from "./index.es105.js";
import { addInlineStyles as x } from "./index.es143.js";
import e from "./index.es144.js";
var y = function y(_ref) {
  var t = _ref.className,
    r = _ref.children,
    s = _ref.background,
    m = _ref.width,
    l = _ref.height,
    n = _ref.borderRadius,
    i = _ref.isCircle,
    o = _ref.isDarkFlare;
  return a.jsx("div", {
    className: p(e.skeletonLine, t, _defineProperty(_defineProperty({}, e.normalFlare, !o), e.darkFlare, o)),
    style: x({
      background: s,
      width: m,
      height: l,
      borderRadius: n,
      isCircle: i
    }),
    children: r
  });
};
export { y as SkeletonLine };